import axios from "axios";
import authService from "../auth/authServices";
import deploymentUrls from "../envs/deploymentConfigs";

const baseApiUrl = deploymentUrls.api;

const axiosInstance = axios.create({
  baseURL: baseApiUrl,
  // headers: {
  //     'Content-Type': 'application/json', // Default headers
  // },
});

// Interceptor to add the Authorization header
axiosInstance.interceptors.request.use(async (config) => {
  const token = await authService.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle 401 errors (e.g., redirect to login)
      console.error("Unauthorized! Redirecting...");
      window.location.href = "/unauthorized";
    }
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Handle 401 errors (e.g., redirect to login)
      console.error("Unauthorized! Redirecting...");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
